<template>
  <div class="news-bread">
    <!-- 面包屑 -->
    <shBread>
      <shBreadItem to="/">首页</shBreadItem>
      <shBreadItem to="/advice/adviceitem"
        ><div class="bread">备考指南</div></shBreadItem
      >
    </shBread>
  </div>
  <div class="news-desc">
    <div class="desc-left">
      <ExamAdviceList :adviceList="adviceList" />
      <div class="pagnation">
        <el-pagination
          v-model:current-page="currentPage"
          v-model:page-size="pageSize"
          @size-change="changeSize"
          @current-change="currentChange"
          :current-page="currentPage"
          :page-sizes="[15, 25, 35, 40]"
          :page-size="pageSize"
          background
          layout="total,  prev, pager, next"
          :total="adviceCount"
        >
        </el-pagination>
      </div>
    </div>

    <div class="desc-right">
      <div class="news-recom"></div>
      <VideoRecommend :VideoReCommend="VideoReCommend" />
    </div>
  </div>
</template>

<script>
import { findVideoRecommand } from "@/api/video";
import { findAdviceList } from "@/api/news";
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";

import VideoRecommend from "@/components/video-recommend.vue";
import ExamAdviceList from "./components/advice-list.vue";
export default {
  components: { VideoRecommend, ExamAdviceList },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const adviceList = ref([]);

    //总页数
    const adviceCount = ref(0);
    //当前页码
    const currentPage = ref(1);
    //每页数
    const pageSize = ref(25);

    const VideoReCommend = ref([]);

    try {
      findAdviceList({
        clID: route.query.clID.split(","),
        size: pageSize.value,
        page: currentPage.value,
      }).then((data) => {
        adviceList.value = data[0].result;
        adviceCount.value = data[0].resultLength[0].totalCount;
      });
    } catch (error) {
      console.log(error);
    }

    //这里有两个clID的时候用，分割使其变成数组
    findVideoRecommand(route.query.clID.split(",")).then((data) => {
      //console.log(data);
      try {
        VideoReCommend.value = data.map((item) => {
          return {
            chID: item.chID,
            maID: item.maID,
            coID: item.coID,
            clID: item.clID,
            leName: item.leName,
            leImg: "/web/" + item.leImg,
            coverImg: "/web/" + item.coverImg,
            grade: item.grade.find((ele) => ele._id == item.gradeID),
            id: item._id,
          };
        });
      } catch (error) {
        console.log(error);
      }
    });
    const currentChange = (page) => {
      try {
        currentPage.value = page;
        findAdviceList({
          clID: route.query.clID.split(","),
          size: pageSize.value,
          page: currentPage.value,
        }).then((data) => {
          adviceList.value = data[0].result;
          adviceCount.value = data[0].resultLength[0].totalCount;
        });
      } catch (error) {
        console.log(error);
      }
      //console.log(page);
    };
    const changeSize = (size) => {
      pageSize.value = size;
    };

    return {
      adviceList,
      VideoReCommend,
      currentPage,
      pageSize,
      adviceCount,
      currentChange,
      changeSize,
    };
  },
};
</script>

<style lang="less" scoped>
.news-bread {
  background: @shColor;
  .bread {
    width: 700px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.news-desc {
  display: flex;
  justify-content: space-between;
  width: 1240px;
  margin: 0 auto;
  .desc-left {
    width: 850px;
    background: #fefefe;
    .pagnation {
      display: flex;
      justify-content: center;
      margin-top: 25px;
      margin-bottom: 25px;
    }
  }
  .desc-right {
    width: 350px;
    //background: #999;
  }
}
</style>
